<template>
    <div v-if="Role === '1'">
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                </el-col>
            </el-row>
            <el-form ref="bannerForm" :model="bannerForm" :rules="bannerFormFules" class="rules">
                <el-form-item label="用户协议" label-width="150px" prop="user">
                    <el-input type="textarea" v-model="bannerForm.user"></el-input>
                </el-form-item>
                <el-form-item label="服务条款" label-width="150px" prop="service">
                    <el-input type="textarea" v-model="bannerForm.service"></el-input>
                </el-form-item>
                <el-form-item label="租赁协议" label-width="150px" prop="liu">
                    <el-input type="textarea" v-model="bannerForm.liu"></el-input>
                </el-form-item>
    
                <el-form-item label-width="150px">
                    <el-button type="primary" @click="onSubmit" v-if="Role === '1'">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    
    </div>
    <h3 v-else>
        暂无权限
    </h3>
</template>

<script>
    import {
        getService,
        getUserX,
        getRentXie,
        patchService,
        patchUserX,
        patchRentXie
    } from '../../api/version'
    
    export default {
        data() {
            return {
                 Role: sessionStorage.power,
                bannerForm: {
                    user: '',
                    liu: '',
                    service: '',
                },
    
                bannerFormFules: {
                    user: [{
                        required: true,
                        message: '请输入用户协议',
                        trigger: 'blur'
                    }],
                    liu: [{
                        required: true,
                        message: '请输入流程规则',
                        trigger: 'blur'
                    }],
                    service: [{
                        required: true,
                        message: '请输入服务条款',
                        trigger: 'blur'
                    }]
                },
    
            }
        },
        created() {
            getUserX().then(res => {
                console.log(res.data)
                this.bannerForm.user = JSON.stringify(res.data.value)
            })
    
            getService().then(res => {
                console.log(res.data)
                this.bannerForm.service = JSON.stringify(res.data.value)
            })
    
            getRentXie().then(res => {
                this.bannerForm.liu = JSON.stringify(res.data.value)
            })
        },
        methods: {
    
            onSubmit() {
    
                this.$refs['bannerForm'].validate((valid) => {
                    if (valid) {
                        let a = patchService(sessionStorage.userId, {
                            value: this.bannerForm.service
                        })
    
    
                        let b = patchUserX(sessionStorage.userId, {
                            value: this.bannerForm.user
                        })
    
    
                        let c = patchRentXie(sessionStorage.userId, {
                            value: this.bannerForm.liu
                        })
    
                        Promise.all([a, b, c]).then(val => {
                            console.log(val)
                            if (val.length) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                            }else(
                                this.$message.error('修改失败')
                            )
                        })
                    }
                })
    
            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .el-textarea .el-textarea__inner {
        height: 300px
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// Rules.vue?2dcbfb83